export const DefaultPortal = 'DEFAULT_PORTAL';
export const SubPortal = 'SUB_PORTAL';
export const FloatingBar = 'floating-bar-portal';
export const WebsiteSettingsAside = 'website-settings-aside-portal';
export const Lightbox = 'lightbox-portal';
export const ExistingVehicles = 'existing-vehicles-portal';
